import type { FC } from "react"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { useTranslation } from "react-i18next"

import type { EntityType } from "types/common.types"

import { getEntityHref } from "helpers/utils/entities"
import CustomLink from "widgets/common/CustomLink"
import EntityIcon from "widgets/common/EntityIcon"
import TruncatedText from "widgets/common/TruncatedText"

interface EntityCellProps {
  entity: EntityType
  id: number
  name: string | null | undefined
  baseOrgURL: string
}

const EntityCell: FC<EntityCellProps> = ({ entity, id, name, baseOrgURL }) => {
  const { t } = useTranslation()
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
      <EntityIcon
        entity={entity}
        variant="avatar"
        tooltip={t(`entities.${entity.toUpperCase()}`)}
      />
      <Box minWidth={0}>
        <CustomLink
          component="div"
          href={getEntityHref(entity, id, baseOrgURL)}
          hover
          bold
        >
          <TruncatedText>{name || <i>{t("generic.UNNAMED")}</i>}</TruncatedText>
          <Typography
            variant="body2"
            color="text.secondary"
            noWrap
          >{`${t("generic.ID")}: ${id}`}</Typography>
        </CustomLink>
      </Box>
    </Box>
  )
}

export default EntityCell
